import React, { useEffect } from "react";
import "../css/Contact.css";
import { useLocation } from "react-router-dom";

const Contact = () => {
  const location = useLocation();

  useEffect(() => {
    if (location.hash === "#xmas-hours") {
      const el = document.getElementById("xmas-hours");
      if (el) {
        el.scrollIntoView({ behavior: "smooth", block: "start" });
      }
    }
  }, [location]);
  return (
    <div className="contact">
      <div className="map__container">
        <h4>Address</h4>
        <p>25, Gloucester Road, Bishopston, BS7 8AA, Bristol</p>
        <div className="map__iframe-container">
          <iframe
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2485.3039287846477!2d-2.5955239229621334!3d51.47093531336601!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x48718e0bd89f0239%3A0x750d425a5b2c128c!2sGloucester%20Road%20Pharmacy!5e0!3m2!1sen!2suk!4v1732661987229!5m2!1sen!2suk"
            style={{
              border: 0,
            }}
            loading="lazy"
          ></iframe>
        </div>
        <p><small>(Tap on the map to get directions to our pharmacy)</small></p>
        <br />
        <h4>Telephone number</h4>
        <p><a href="tel:01179491143">0117 949 1143</a> <small>(Click/Tap to give us a ring)</small></p>
        <br /> 
        <h4>Email</h4>
        <p><a href="mailto:info@gloucesterroadpharmacy.co.uk">info@gloucesterroadpharmacy.co.uk</a> <small>(Click/Tap to send us an email)</small></p>
        <br />
        <h4>Complaints & Feedback</h4>
        <p>We strive to provide excellent service to all our customers. If you have any complaints, concerns, or feedback about our services, please don't hesitate to contact us via email or phone. We take all feedback seriously and will work to resolve any issues promptly.</p>
        <br />
        <div className="opening-hours">
          <div className="opening-hours__column">
            <h4>Opening hours</h4>
            <p>Mon to Fri : 9am - 6pm</p>
            <p>Sat : 9am - 5.30pm</p>
            <p>Sun : Closed</p>
          </div>
          {/* <div
            id="xmas-hours"
            className="opening-hours__column opening-hours__column--xmas"
          >
            <h4>Christmas week opening hours</h4>
            <p>Christmas Eve (24th) : 9am - 6pm</p>
            <p>Christmas Day (25th) : 2.30pm - 4.30pm <small>(for emergencies)</small></p>
            <p>Boxing Day (26th) : Closed</p>
            <p>Saturday 27th : 9am - 5.30pm</p>
          </div> */}
        </div>
      </div>
    </div>
  );
};

export default Contact;
